import type { ReactNode } from 'react'
import RogerioMascot from './RogerioMascot'
import { bookingLabel, individualBookingUrl } from './siteDestinations'
import { ActionLink, PaperCard } from './ui/Workshop' // termo-ok: nome técnico do arquivo de componentes
import './landing-illustrated.css'

export type OpeningFacts = readonly [readonly [string, string], readonly [string, string], readonly [string, string], readonly [string, string]]

export type PageOpeningProps = {
  eyebrow: string
  title: ReactNode
  intro: ReactNode
  note?: ReactNode
  rogerio: { pose: string; text: string }
  facts: OpeningFacts
  flow: readonly string[]
  flowLabel?: string
  secondary: { href: string; label: string }
}

/** A mesma porta em cada página; o assunto muda nos textos, na ficha e na faixa. */
export default function PageOpening({ eyebrow, title, intro, note, rogerio, facts, flow, flowLabel = 'Um caminho para começar', secondary }: PageOpeningProps) {
  return <>
    <section className="of-abertura" id="porta" aria-labelledby="porta-title">
      <span className="of-nuvenzinha of-nuvenzinha--esq" aria-hidden="true" />
      <span className="of-nuvenzinha of-nuvenzinha--dir" aria-hidden="true" />
      <div className="of-wrap">
        <div className="of-abertura__texto">
          <p className="of-selo"><span className="of-selo__ponto" aria-hidden="true" />{eyebrow}</p>
          <h1 id="porta-title">{title}</h1>
          <p className="of-abertura__sub">{intro}</p>
          <div className="of-acoes">
            <ActionLink href={individualBookingUrl} target="_blank" rel="noopener noreferrer">{bookingLabel}</ActionLink>
            <a className="of-button of-button--secondary" href={secondary.href}>{secondary.label}</a>
          </div>
          <p className="of-promessa"><strong>30 minutos</strong> <span className="of-promessa__ponto">·</span> online <span className="of-promessa__ponto">·</span> gratuita <span className="of-promessa__ponto">·</span> você escolhe o horário</p>
          {note && <p className="of-abertura__nota">{note}</p>}
        </div>
        <div className="of-retrato-wrap">
          <figure className="of-retrato">
            <img src="/assets/photography/arthur-corcovado.jpeg" alt="Arthur, que conduz a primeira conversa e o acompanhamento." width="1232" height="1600" loading="eager" decoding="async" />
            <figcaption>Arthur <small>Ensina adultos há mais de dez anos</small></figcaption>
          </figure>
          <div className="of-hospede">
            <p>{rogerio.text}<span aria-hidden="true">↴</span></p>
            <RogerioMascot pose={rogerio.pose} />
            <span className="of-hospede__nome">Rogério <span aria-hidden="true">✳</span></span>
          </div>
        </div>
      </div>
      <section className="of-abertura__ficha" aria-label="O formato em números">
        <div className="of-wrap of-ficha">
          {facts.map(([value, text]) => <PaperCard key={value}><strong>{value}</strong><span>{text}</span></PaperCard>)}
        </div>
      </section>
    </section>
    <section className="of-faixa" aria-label={flowLabel}>
      <div className="of-faixa__trilho">
        <ul className="of-faixa__lista">{flow.map(step => <li key={step}>{step}</li>)}</ul>
        <ul className="of-faixa__lista" aria-hidden="true">{flow.map(step => <li key={step}>{step}</li>)}</ul>
      </div>
    </section>
  </>
}
